import { render, staticRenderFns } from "./ModalNombrarDescarga.vue?vue&type=template&id=8c2ef062"
import script from "./ModalNombrarDescarga.vue?vue&type=script&lang=js"
export * from "./ModalNombrarDescarga.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c2ef062')) {
      api.createRecord('8c2ef062', component.options)
    } else {
      api.reload('8c2ef062', component.options)
    }
    module.hot.accept("./ModalNombrarDescarga.vue?vue&type=template&id=8c2ef062", function () {
      api.rerender('8c2ef062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/portal/buscador/ModalNombrarDescarga.vue"
export default component.exports